import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { cn } from '../../../lib/utils';
import { SpecraTag } from '../ensigns/tag';
import { SpecraText } from '../ensigns/typography';
const barClass = {
    neutral: 'border border-dashed border-muted-foreground/60 bg-transparent',
    success: 'bg-success',
    warning: 'bg-warning',
    danger: 'bg-danger/80',
    info: 'bg-info'
};
const finitePercent = (value)=>Number.isNaN(value) ? 0 : Math.min(100, Math.max(0, value));
/** One labeled percentage-based schedule track. */ export function SpecraScheduleRow({ bars, label, labelText, markers = [] }) {
    const accessibleLabelText = typeof label === 'string' ? label : labelText ?? 'Schedule';
    const normalizedBars = bars.map((bar)=>{
        const start = finitePercent(bar.start);
        return {
            ...bar,
            start,
            width: Math.min(finitePercent(bar.width), 100 - start)
        };
    });
    const normalizedMarkers = markers.map((marker)=>({
            ...marker,
            position: finitePercent(marker.position)
        }));
    const barDescription = normalizedBars.map((bar)=>`${bar.label}, starts at ${bar.start} percent, spans ${bar.width} percent`).join('; ');
    const markerDescription = normalizedMarkers.filter((marker)=>marker.label).map((marker)=>`${marker.label}, at ${marker.position} percent`).join('; ');
    const accessibleLabel = `${accessibleLabelText} schedule: ${[
        barDescription,
        markerDescription
    ].filter(Boolean).join('; ')}`;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(SpecraText, {
                className: "self-center truncate",
                size: "caption",
                tone: "secondary",
                children: label
            }),
            /*#__PURE__*/ _jsxs("div", {
                "aria-label": accessibleLabel,
                className: "relative my-2 h-5 rounded-sm bg-card",
                role: "img",
                children: [
                    normalizedMarkers.map((marker)=>/*#__PURE__*/ _jsx("span", {
                            "aria-hidden": "true",
                            className: "absolute inset-y-[var(--component-schedule-marker-bleed)] w-px bg-danger",
                            style: {
                                left: `${marker.position}%`
                            },
                            title: marker.label
                        }, marker.id)),
                    normalizedBars.map((bar)=>/*#__PURE__*/ _jsx(SpecraTag, {
                            "aria-hidden": "true",
                            className: cn('absolute top-1 h-3 overflow-hidden p-0', barClass[bar.tone ?? 'neutral']),
                            style: {
                                left: `${bar.start}%`,
                                width: `${bar.width}%`
                            },
                            title: bar.label
                        }, bar.id))
                ]
            })
        ]
    });
}
